import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    '& .modal-trigger': {
      marginRight: '10px'
    }
  },
  cellContent: {
    borderRadius: '2px',
    display: 'flex',
    alignItems: 'center',
    padding: '5px 10px'
  },
  cellLeft: {
    width: '100%'
  },
  exportCSV: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-around'
  },
  rightAlign: {
    textAlign: 'right'
  },
  table: {
    boxShadow: 'none'
  },
  wrappedTooltip: {
    marginRight: '10px'
  }
});
export default useStyles;